import { Auth } from '../types/common/httpRequest'
import {
    ConfirmDeviceDraftDepositRequest,
    ConfirmDeviceDraftDepositResponse,
    CreateDeviceDraftDepositRequest,
    CreateDeviceDraftDepositResponse,
    DraftFromVoucherRequest,
    DraftFromVoucherResponse,
    VoucherAmountResponse,
    VoucherRequest,
    VoucherResponse
} from '../types/pos/deposit'
import { HttpService } from './httpService'

const api = {
    voucher: '/cashier-app/money-transfer/voucher/draft/convert',
    draftFromVoucher:
        '/cashier-app/money-transfer/voucher/draft/{voucherCode}?targetVoucherType={targetVoucherType}',
    getVoucherAmount: '/cashier-app/money-transfer/voucher/draft',
    confirmDeviceDraftDeposit:
        '/cashier-app/money-transfer/voucher/draft/confirm',
    getVoucherAmountChanges: '/cashier-app/money-transfer/voucher/draft/changes'
}

export class TransactionService {
    static async CreateVoucher(dto: VoucherRequest): Promise<VoucherResponse> {
        return HttpService.Post(api.voucher, dto, Auth.Cashier)
    }

    static async CreateDeviceDraftDeposit(
        dto: CreateDeviceDraftDepositRequest
    ): Promise<CreateDeviceDraftDepositResponse> {
        return HttpService.Post(api.getVoucherAmount, dto, Auth.Cashier)
    }

    static async ConfirmDeviceDraftDeposit(
        dto: ConfirmDeviceDraftDepositRequest
    ): Promise<ConfirmDeviceDraftDepositResponse> {
        return HttpService.Post(
            api.confirmDeviceDraftDeposit,
            dto,
            Auth.Cashier
        )
    }

    static async CreateDraftFromVoucher(
        dto: DraftFromVoucherRequest
    ): Promise<DraftFromVoucherResponse> {
        return HttpService.Post(
            api.draftFromVoucher
                .replace('{voucherCode}', dto.voucherCode)
                .replace('{targetVoucherType}', dto.targetVoucherType),
            {},
            Auth.Cashier
        )
    }

    static async GetVoucherAmount(): Promise<VoucherAmountResponse> {
        return HttpService.Get(api.getVoucherAmount, Auth.Cashier)
    }

    static async GetVoucherAmountChanges(
        since?: string,
        timeoutMs = 15000
    ): Promise<VoucherAmountResponse> {
        if (!since) {
            return HttpService.Get(api.getVoucherAmountChanges, Auth.Cashier)
        }

        const query = new URLSearchParams({
            since,
            timeoutMs: String(timeoutMs)
        })
        return HttpService.Get(
            `${api.getVoucherAmountChanges}?${query.toString()}`,
            Auth.Cashier
        )
    }
}
